/* Devocione V7.2 — one Inbox bridge for masthead, footer and help center.
   Only the activator is hidden on mobile; the conversation host is never hidden. */
(() => {
  'use strict';
  if (window.DevocioneInbox) return;
  const mobile = '(max-width:989px)';
  const hostSelector = 'shopify-chat,#ShopifyChat';
  const launcherSelector = '[data-dv7-inbox-launcher],button.chat-toggle,.chat-app > button,button[data-testid="chat-toggle"],button[data-testid="chat-activator"],button[part~="launcher"],button[aria-controls*="chat"][aria-expanded]';
  const roots = new WeakSet();
  const hostSet = new WeakSet();
  let frame = 0, pending = false;
  function markRoot(root) {
    if (!root || roots.has(root)) return;
    roots.add(root);
    // Shadow styles are scoped to the observed Inbox root, and never affect desktop.
    if (root instanceof ShadowRoot) {
      const style = document.createElement('style');
      style.dataset.dv7InboxStyle = '';
      style.textContent = `@media ${mobile}{[data-dv7-inbox-launcher]{display:none!important;pointer-events:none!important}}`;
      root.appendChild(style);
    }
    const observer = new MutationObserver(queueScan);
    observer.observe(root, { childList: true, subtree: true });
  }
  function inspect(root, found, depth = 0) {
    if (!root || depth > 5) return;
    markRoot(root);
    root.querySelectorAll(launcherSelector).forEach(button => {
      if (!(button instanceof HTMLElement)) return;
      if (!button.hasAttribute('data-dv7-inbox-launcher')) button.setAttribute('data-dv7-inbox-launcher', '');
      found.add(button);
    });
    // Older Inbox versions expose just one top-level expanded activator.
    if (!found.size) {
      [...root.querySelectorAll('button[aria-expanded]')].filter(button => {
        const label = `${button.getAttribute('aria-label') || ''} ${button.textContent || ''}`;
        return /chat|conversa|mensaje|chatear/i.test(label) && !/cerrar|close|enviar|send/i.test(label);
      }).slice(0, 1).forEach(button => { button.setAttribute('data-dv7-inbox-launcher', ''); found.add(button); });
    }
    root.querySelectorAll('*').forEach(node => { if (node.shadowRoot) inspect(node.shadowRoot, found, depth + 1); });
  }
  function scan() {
    const found = new Set();
    document.querySelectorAll(hostSelector).forEach(host => {
      if (host.shadowRoot) inspect(host.shadowRoot, found);
      else inspect(host, found);
      if (!hostSet.has(host)) {
        hostSet.add(host);
        // Attaching a shadow root itself does not emit a DOM mutation.
        [80, 350, 1000, 2500, 6000, 12000].forEach(delay => setTimeout(queueScan, delay));
      }
    });
    return [...found].filter(node => node.isConnected);
  }
  function queueScan() {
    if (frame) return;
    frame = requestAnimationFrame(() => { frame = 0; scan(); });
  }
  function openExisting() {
    const buttons = scan();
    const launcher = buttons.find(button => !button.disabled);
    try {
      if (launcher) {
        if (launcher.getAttribute('aria-expanded') !== 'true') launcher.click();
        return true;
      }
      const chat = document.querySelector('shopify-chat');
      if (typeof chat?.show === 'function') { chat.show(); return true; }
    } catch (_) { /* Fallback remains an actual contact URL. */ }
    return false;
  }
  function statusNode() {
    let status = document.getElementById('Dv7InboxStatus');
    if (!status) {
      status = document.createElement('div'); status.id = 'Dv7InboxStatus';
      status.className = 'dv7-inbox-status'; status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite'); status.hidden = true;
      document.body.appendChild(status);
    }
    return status;
  }
  function finishOpen(link) {
    document.querySelectorAll('dv7-masthead').forEach(header => header.close?.());
    link?.removeAttribute('aria-busy');
    const status = document.getElementById('Dv7InboxStatus'); if (status) status.hidden = true;
    pending = false;
  }
  async function open(link) {
    if (openExisting()) { finishOpen(link); return true; }
    if (pending) return false;
    pending = true; link?.setAttribute('aria-busy', 'true');
    const status = statusNode(); status.hidden = false; status.textContent = 'Abriendo el chat…';
    for (let attempt = 0; attempt < 20; attempt++) {
      await new Promise(resolve => setTimeout(resolve, 250));
      if (openExisting()) { finishOpen(link); return true; }
    }
    pending = false; link?.removeAttribute('aria-busy');
    // Do not silently send emails or create a simulated chat when Inbox is blocked.
    status.replaceChildren(document.createTextNode('El chat no está disponible en este momento. '));
    const fallback = document.createElement('a');
    fallback.href = link?.href || '/pages/contact';
    fallback.textContent = 'Contactar con Devocione'; status.appendChild(fallback);
    const close = document.createElement('button'); close.type = 'button'; close.textContent = '×';
    close.setAttribute('aria-label', 'Cerrar aviso'); close.addEventListener('click', () => { status.hidden = true; }); status.appendChild(close);
    return false;
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('[data-dv7-chat]'); if (!link) return;
    event.preventDefault(); open(link);
  });
  function boot() {
    scan();
    const observer = new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.(hostSelector) || node.querySelector?.(hostSelector))))) queueScan();
    });
    observer.observe(document.body, { subtree: true, childList: true });
    customElements.whenDefined('shopify-chat').then(queueScan);
  }
  window.DevocioneInbox = { open, refresh: queueScan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();
